import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-alert-modal',
	templateUrl: './alert-modal.component.html',
	styleUrls: ['./alert-modal.component.scss'],
})
export class AlertModalComponent implements OnInit {
	@Input() title: any;
	@Input() message: any;
	@Input() btnOkText: any;
	@Input() btnCancelText: any;

	constructor(private activeModal: NgbActiveModal) {}

	ngOnInit(): void {}

	public decline() {
		this.activeModal.close(false);
	}

	public accept() {
		this.activeModal.close(true);
	}

	public dismiss() {
		this.activeModal.dismiss();
	}
}
